import React, { useEffect } from "react";
import SuccessLoginImg from "../../assets/images/SuccessLogin.png";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axiosWithAuth from "../../utils/axiosWithAuth";

const SuccessLogin = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Function to save repair data to backend
  const saveRepairToBackend = async (tempRepairId) => {
    try {
      // Get temp repair data from localStorage
      const tempRepairData = localStorage.getItem(tempRepairId);
      if (!tempRepairData) {
        console.error("Temp repair data not found:", tempRepairId);
        return null;
      }
      
      const repairData = JSON.parse(tempRepairData);
      console.log("Repair data to be saved:", repairData);
      
      // Get token
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("Token not found");
        return null;
      }
      
      // Get user information
      const userString = localStorage.getItem("user");
      if (!userString) {
        console.error("User information not found");
        return null;
      }
      
      const user = JSON.parse(userString);
      console.log("User to be saved:", user);
      
      // Property data
      const propertyData = {
        propertyType: repairData.repairStyle,
        propertyStatus: repairData.repairTariff || "67ebdd9e9b1339045878ce2e", // Default status
        area: repairData.property.area,
        height: repairData.property.height || 2,
        roomCount: repairData.property.roomCount || repairData.rooms.length,
        doorCount: repairData.property.doorCount || 0,
        windowCount: repairData.property.windowCount || 0
      };
      
      console.log("Sending property data:", propertyData);
      
      // Setup baseURL and headers for API
      try {
        // Create property record
        const propertyResponse = await axiosWithAuth().post('/properties', propertyData);
        
        if (!propertyResponse.data || !propertyResponse.data._id) {
          console.error("Failed to create property:", propertyResponse);
          return null;
        }
        
        const propertyId = propertyResponse.data._id;
        console.log("Property created:", propertyId);
        
        // Room data
        const rooms = repairData.rooms.map(room => ({
          name: room.name,
          area: room.area,
          type: room.type || "room"
        }));
        
        // Create rooms
        const roomsResponse = await axiosWithAuth().post('/rooms', {
          propertyId: propertyId,
          rooms: rooms
        });
        
        if (!roomsResponse.data || !roomsResponse.data.rooms) {
          console.error("Failed to create rooms:", roomsResponse);
          return null;
        }
        
        console.log("Rooms created:", roomsResponse.data.rooms);
        
        // Create repair record
        const repairResponse = await axiosWithAuth().post('/repairs', {
          propertyId: propertyId,
          userId: user._id,
          status: "draft",
          totalPrice: repairData.totalPrice || 0
        });
        
        if (!repairResponse.data || !repairResponse.data._id) {
          console.error("Failed to create repair:", repairResponse);
          return null;
        }
        
        const repairId = repairResponse.data._id;
        console.log("Repair created:", repairId);
        
        // Success - created repair in backend
        return repairId;
      } catch (error) {
        console.error("Error saving to backend:", error);
        return null;
      }
    } catch (error) {
      console.error("Backend save error:", error);
      if (error.response) {
        console.error("API error response:", error.response.data);
        console.error("API error status:", error.response.status);
      }
      return null;
    }
  };

  useEffect(() => {
    // Check localStorage for temporary repair ID or pending repair ID
    const tempRepairId = Object.keys(localStorage).find(key => key.startsWith('temp-'));
    const pendingRepairId = localStorage.getItem('pendingRepairId');
    
    console.log("SuccessLogin - Found tempRepairId:", tempRepairId);
    console.log("SuccessLogin - Found pendingRepairId:", pendingRepairId);
    
    const redirectToPage = async () => {
      // Wait for login to complete
      await new Promise(resolve => setTimeout(resolve, 500));
      
      if (pendingRepairId) {
        console.log("SuccessLogin - Checking pendingRepairId:", pendingRepairId);
        
        // Try to save to backend
        const backendId = await saveRepairToBackend(pendingRepairId);
        
        if (backendId) {
          console.log("SuccessLogin - Repair saved to backend, redirecting:", backendId);
          localStorage.removeItem('pendingRepairId');
          window.location.replace(`/maintenance/${backendId}`);
        } else {
          console.log("SuccessLogin - Backend save failed, continuing with temp ID");
          localStorage.removeItem('pendingRepairId');
          window.location.replace(`/maintenance/${pendingRepairId}`);
        }
      } else if (tempRepairId) {
        console.log("SuccessLogin - Checking tempRepairId:", tempRepairId);
        
        // Try to save to backend
        const backendId = await saveRepairToBackend(tempRepairId);
        
        if (backendId) {
          console.log("SuccessLogin - Repair saved to backend, redirecting:", backendId);
          window.location.replace(`/maintenance/${backendId}`);
        } else {
          console.log("SuccessLogin - Backend save failed, continuing with temp ID");
          window.location.replace(`/maintenance/${tempRepairId}`);
        }
      } else {
        console.log("SuccessLogin - No repair ID found, navigating to account");
        navigate("/account");
      }
    };
    
    // Redirect after 1.5 seconds
    const timer = setTimeout(() => {
      redirectToPage();
    }, 1500);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="succcesslogin-section">
      <img src={SuccessLoginImg} alt="success" />
      <h4 className="text-center">{t("successLogin.0")}</h4>
      <p className="text-center">{t("successLogin.1")}</p>
    </div>
  );
};

export default SuccessLogin;
